export const mockUser = {
  id: "usr_7x2kq9",
  name: "James Hargreaves",
  email: "james.hargreaves@gmail.com",
  phone: "07812 456 789",
  postcode: "B15 2TT",
  memberSince: "February 2024",
  avatarInitials: "JH",
};

export const mockBookings = [
  {
    id: "CLR-20260318",
    service: "Man & Van",
    icon: "ri-truck-line",
    status: "completed",
    date: "18 March 2026",
    timeSlot: "09:00 – 11:00",
    address: "42 Moseley Road, Birmingham, B12 9AD",
    items: ["Wardrobe x1", "Sofa x1", "Misc bags x4"],
    total: 149.99,
    receiptUrl: "#",
    wasteNote: "WT-2026-0318-CLR",
  },
  {
    id: "CLR-20260204",
    service: "Sofa Removal",
    icon: "ri-sofa-line",
    status: "completed",
    date: "4 February 2026",
    timeSlot: "11:00 – 13:00",
    address: "42 Moseley Road, Birmingham, B12 9AD",
    items: ["Corner sofa x1"],
    total: 73.49,
    receiptUrl: "#",
    wasteNote: "WT-2026-0204-CLR",
  },
  {
    id: "CLR-20251112",
    service: "House Clearance",
    icon: "ri-home-smile-line",
    status: "completed",
    date: "12 November 2025",
    timeSlot: "08:00 – 12:00",
    address: "7 Sycamore Lane, Bromsgrove, B61 7EA",
    items: ["Full house clearance — 3 bed"],
    total: 499.0,
    receiptUrl: "#",
    wasteNote: "WT-2025-1112-CLR",
  },
  {
    id: "CLR-20260402",
    service: "Bin Collection",
    icon: "ri-recycle-line",
    status: "upcoming",
    date: "2 April 2026",
    timeSlot: "08:00 – 10:00",
    address: "42 Moseley Road, Birmingham, B12 9AD",
    items: ["General waste bin", "Recycling bin"],
    total: 64.99,
    receiptUrl: "#",
    wasteNote: null,
  },
];

export const mockPaymentMethods = [
  {
    id: "pm_visa_4242",
    type: "visa",
    icon: "ri-bank-card-line",
    label: "Visa ending ·· 4242",
    expiry: "09/27",
    isDefault: true,
  },
  {
    id: "pm_mastercard_8831",
    type: "mastercard",
    icon: "ri-bank-card-2-line",
    label: "Mastercard ending ·· 8831",
    expiry: "03/26",
    isDefault: false,
  },
  {
    id: "pm_paypal",
    type: "paypal",
    icon: "ri-paypal-line",
    label: "PayPal — james.h@gmail.com",
    expiry: null,
    isDefault: false,
  },
];

export const mockAddresses = [
  {
    id: "addr_1",
    label: "Home",
    line1: "42 Moseley Road",
    line2: "Birmingham",
    postcode: "B12 9AD",
    isDefault: true,
  },
  {
    id: "addr_2",
    label: "Previous",
    line1: "7 Sycamore Lane",
    line2: "Bromsgrove",
    postcode: "B61 7EA",
    isDefault: false,
  },
];
